/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IntegrationDtoFromJSON, IntegrationDtoToJSON, } from './IntegrationDto.js';
/**
 * Check if a given object implements the ListIntegrationsResult interface.
 */
export function instanceOfListIntegrationsResult(value) {
    if (!('integrations' in value) || value['integrations'] === undefined)
        return false;
    return true;
}
export function ListIntegrationsResultFromJSON(json) {
    return ListIntegrationsResultFromJSONTyped(json, false);
}
export function ListIntegrationsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'integrations': (json['integrations'].map(IntegrationDtoFromJSON)),
    };
}
export function ListIntegrationsResultToJSON(json) {
    return ListIntegrationsResultToJSONTyped(json, false);
}
export function ListIntegrationsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'integrations': (value['integrations'].map(IntegrationDtoToJSON)),
    };
}
